module.exports = __webpack_public_path__ + "img/44.2d8393c6.jpg";